<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('change_of_grade_request_form')"
                        :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('change_of_grade_request_form')"
                              :isFilter="false"/>
            </template>
          <div v-if="instructorCourseStudentList && instructorCourseStudentList.length > 0">
              <div class="row data-form">
                  <div class="col-12">
                      <div class="mb-4">
                          <h6 class="text-uppercase mb-0">{{ $t('information').toUpper() }}</h6>
                      </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                      <b-form-group :label="$t('name')">{{ gradeInstructorData.name}}</b-form-group>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                      <b-form-group :label="$t('surname')">{{gradeInstructorData.surname}}</b-form-group>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                      <b-form-group :label="$t('semester')">{{gradeInstructorData.semester}}</b-form-group>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                      <b-form-group :label="$t('academic_year')">{{gradeInstructorData.academic_year}}</b-form-group>
                  </div>
              </div>
              <hr>
              <div class="my-3 d-inline-block"></div>
              <div class="mb-4">
                  <h6 class="text-uppercase mb-0">{{ $t('application_information').toUpper() }}</h6>
              </div>
              <ValidationObserver ref="gradeChangeForm">
                  <b-row>
                      <b-col cols="12" md="6">
                          <ValidationProvider name="section_id" rules="required" v-slot="{valid, errors}">
                              <b-form-group :label="$t('courses')">
                                  <multi-selectbox type="text"
                                                   v-model="formData.section_id"
                                                   :options="sectionOption"
                                                   :multiple="false"
                                                   :close-on-select="false"
                                                   :validate-error="errors[0]"/>
                                  <div class="current-grade" role="status" aria-live="polite">
                                      <span>{{ $t('current_grade') }}:</span>
                                      <strong class="current-grade__value">{{ currentGrade }}</strong>
                                  </div>
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col cols="12" md="6">
                          <ValidationProvider name="student_program_id" rules="required" v-slot="{ valid, errors }">
                              <b-form-group :label="$t('student')">
                                  <multi-selectbox
                                      v-model="formData.student_program_id"
                                      :options="studentOptions"
                                      :multiple="false"
                                      :close-on-select="true"
                                      :validate-error="errors[0]"
                                  />
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col cols="12" md="6">
                          <ValidationProvider name="new_letter_grade" rules="" v-slot="{ valid, errors }">
                              <b-form-group :label="$t('new_letter_grade')">
                                  <grade-selectbox v-model="formData.new_letter_grade"
                                                   :grading-system-id-required="false"
                                                   :point-greater-than="0"
                                                   value-type="grade"
                                                   :validateError="errors[0]"
                                  />
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                      <b-col cols="12" md="6">
                          <ValidationProvider name="reason" rules="" v-slot="{valid, errors}">
                              <b-form-group :label="$t('reason')">
                                  <b-form-textarea v-model="formData.reason"
                                                   :class="errors[0] ? 'is-invalid':''"
                                                   rows="5"
                                  />
                                  <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                              </b-form-group>
                          </ValidationProvider>
                      </b-col>
                  </b-row>
              </ValidationObserver>
              <div class="d-flex justify-content-center">
                  <b-form-group>
                      <b-button variant="primary" @click="save">{{ $t('save') }}</b-button>
                  </b-form-group>
              </div>
          </div>
            <div v-else>
                <div class="message-box" v-if="message && !showSuccessMessage">
                    <b-alert show variant="info" class="d-flex align-items-center">
                        <b-icon icon="info-circle"></b-icon>
                        <div class="alert-content ml-2">
                            <p class="mb-0 font-weight-bold">{{ $t('api.' + message) }}</p>
                        </div>
                    </b-alert>
                </div>
            </div>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import GradeSelectbox from "@/components/interactive-fields/GradeSelectbox.vue";
/*import StudentListSelectbox from "@/components/interactive-fields/StudentListSelectbox.vue";*/
import GradeChangeService from "@/services/GradeChangeService";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        ValidationProvider,
        ValidationObserver,

      /*  StudentListSelectbox,*/
        GradeSelectbox,
        MultiSelectbox,
    },
    data() {
        return {
            formData:{
                section_id: null,
                student_program_id: null,
            },
            formProcess:null,
            gradeInstructorData:{},
            instructorCourseStudentList: [],
            studentOptions:[],
            sectionOption:[],
            showSuccessMessage:false,
            message:null,
        }
    },
    metaInfo() {
        return {
            title: this.$t('change_of_grade_request_form')
        }
    },
    computed: {
        currentGrade() {
            const selectedCourse = this.instructorCourseStudentList.find(
                item => item.section_id === this.formData.section_id
            );
            const selectedStudent = selectedCourse?.students?.find(
                student => student.student_program_id === this.formData.student_program_id
            );

            return selectedStudent?.letter_grade ?? '-';
        },
    },
    watch: {
        'formData.section_id'(newVal) {
            const selected = this.instructorCourseStudentList.find(
                item => item.section_id === newVal
            );

            if (selected && Array.isArray(selected.students)) {
                this.studentOptions = selected.students.map(s => ({
                    value: s.student_program_id,
                    text: `${s.name} ${s.surname} - ${s.student_number}`,
                }));
            } else {
                this.studentOptions = [];
            }

            this.formData.student_program_id = null;
        },
    },
    methods: {
        async getFormData() {
            try {
                const response = await GradeChangeService.getGradeChangeForm()
                this.gradeInstructorData = response.data.data
            }catch (error) {
                this.message=error.data.message
                this.showErrors(error)
            }
        },
        async getInstructorCoursesAndStudents() {
            try {
                const response = await GradeChangeService.getInstructorCoursesAndStudents();
                const list = response.data?.data || [];

                this.instructorCourseStudentList = list;

                this.sectionOption = list.map(item => ({
                    value: item.section_id,
                    text: `${item.course_code} / ${item.course_name} - Section/${item.section}`,
                }));

            } catch (error) {
                this.message=error.data.message
                this.showErrors(error);
            }
        },
       async save(){
            if (!await this.$refs.gradeChangeForm.validate()) return
            try {
                const res = await GradeChangeService.store(this.formData)
                this.$toast.success(this.$t(res.data.message))
                this.$router.push('/my-instructor-requests/0')
            }catch (error){
                this.showErrors(error,this.$refs.gradeChangeForm)
            }
        }
    },
    async created() {
        await this.getFormData()
        await this.getInstructorCoursesAndStudents()
    },
};
</script>

<style scoped>
.current-grade {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.5rem;
    margin-top: 0.75rem;
    padding: 0.75rem 1rem;
    border: 1px solid #b8dce9;
    border-left: 4px solid #16718f;
    border-radius: 0.375rem;
    background-color: #eef7fb;
    color: #234454;
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.5;
}

.current-grade__value {
    color: #123747;
    font-size: 1.25rem;
    font-weight: 700;
}
</style>
